export function dailySelection<T extends { id: string }>(
  items: T[],
  playerId: string,
  dateKey: string,
  count: number,
): T[] {
  const seedText = `${playerId}:${dateKey}`;
  let seed = 2166136261;
  for (const char of seedText) seed = Math.imul(seed ^ char.charCodeAt(0), 16777619);
  const scored = items.map((item) => {
    let score = seed;
    for (const char of item.id) score = Math.imul(score ^ char.charCodeAt(0), 16777619);
    return { item, score: score >>> 0 };
  });
  return scored
    .sort((a, b) => a.score - b.score)
    .slice(0, count)
    .map(({ item }) => item);
}
